import * as STD               from '@emersya/mpa-std-lib';
import CM                     from '@emersya/mpa-components-manager-lib';
import { InputButton, Modal } from '@emersya/mpa-components-lib';

export interface IStandingNumericOptionsComponentConfiguration extends Modal.Configuration {
};

export class StandingNumericOptionsComponent extends Modal.Component<
	null,
	null
>
{
	protected override canBeClosed() : boolean {
		return true;
	};

	protected override onOpen() {
	};

	protected override onClose() {
	};

	protected override async onValidate(){
		return null;
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		const closeButton = <InputButton.Component> this.component_find('@:header.close');
		if (!closeButton) {
			this.component_throwUserError('Missing close button');
		}
		closeButton.component_DOM.innerHTML = 'q';
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		const planner = app.viewer.planner;
		if (!planner) {
			this.component_throwUserError('');
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingNumericOptionsComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};

import manifestXMLSource from './StandingNumericOptions.xml';
import './StandingNumericOptions.scss';

export namespace NS {
	export const Component = StandingNumericOptionsComponent;
	export type Component = StandingNumericOptionsComponent;
	export type Configuration = IStandingNumericOptionsComponentConfiguration;
}

CM.declare({
	id :       'standing-numericOptions',
	type :     StandingNumericOptionsComponent,
	manifest : manifestXMLSource
});
